import { render, staticRenderFns } from "./CaptainLedger.vue?vue&type=template&id=9805c788&scoped=true"
import script from "./CaptainLedger.vue?vue&type=script&lang=js"
export * from "./CaptainLedger.vue?vue&type=script&lang=js"
import style0 from "./CaptainLedger.vue?vue&type=style&index=0&id=9805c788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9805c788",
  null
  
)

export default component.exports